import {
  Component,
  Input,
  AfterViewInit,
  OnInit,
  Output,
  EventEmitter,
  OnDestroy,
} from '@angular/core';
import { select, Store } from '@ngrx/store';
import { AsyncPipe, Location, NgIf } from '@angular/common';
import { RequestVerificationCodeAction, ScriptLoadedAction } from './actions';
import {
  greenId_IsLoading,
  greenId_Model,
  greenId_ScriptLoaded,
  greenId_SubmittedDate,
} from './selectors';
import { GreenIdDocsVerificationDialog } from './docs-verification-dialog/docs-verification-dialog.component';
import { GreenIdConsentDialog } from './consent-dialog/consent-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { GreenIdModel } from './state';
import { distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { Helper } from '@ifaa-components/ui-components';
import { MemberPortalSharedState } from 'src/app/modules/shared/store/shared.states';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'greenid',
  templateUrl: './greenid.component.html',
  styleUrls: ['./greenid.component.scss'],
})
export class GreenIdComponent implements OnInit, OnDestroy, AfterViewInit {
  model$ = this.store.pipe(select(greenId_Model));
  isLoading$ = this.store.pipe(select(greenId_IsLoading));
  submittedDate$ = this.store.pipe(select(greenId_SubmittedDate));
  ScriptLoaded$ = this.store.pipe(select(greenId_ScriptLoaded));
  @Output() onVerified: EventEmitter<boolean> = new EventEmitter();
  private readonly _destroying$ = new Subject<void>();

  helper = new Helper();
  member = null;
  aId = 0;

  @Input() set accountid(val: number) {
    if (val) {
      this.store.dispatch(RequestVerificationCodeAction({ account: val }));
      this.aId = val;
    }
  }

  @Input() updateDataLink: string = '';

  constructor(
    public store: Store<MemberPortalSharedState>,
    private location: Location,
    public dialog: MatDialog,
  ) {}

  ngAfterViewInit(): void {
    this.model$.pipe(takeUntil(this._destroying$)).subscribe((x) => {
      if (x) {
        if (this.onVerified) {
          this.onVerified.emit(x.verified);
        }
      }
    });

    this.submittedDate$
      .pipe(distinctUntilChanged(), takeUntil(this._destroying$))
      .subscribe((x) => {
        if (x) {
          this.store.dispatch(
            RequestVerificationCodeAction({ account: this.aId })
          );
        }
      });
  }

  ngOnDestroy() {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }

  async onStartClick(model: GreenIdModel) {

    if (!this.aId || !model.verificationId) {
      return;
    }

    if (model.hasConsented) {
      this.openDocsVerificationDialog(model);
      return;
    }

    this.dialog
      .open(GreenIdConsentDialog, {
        width: '600px',
        disableClose: true,
        panelClass: 'cirt-theme',
        data: { accountId: this.aId, verificationId: model.verificationId },
      })
      .afterClosed()
      .subscribe((result) => {
        if (result === 'agree') {
          this.openDocsVerificationDialog(model);
        }
      });
  }

  private openDocsVerificationDialog(model: GreenIdModel) {
    this.dialog.open(GreenIdDocsVerificationDialog, {
      width: '1000px',
      disableClose: true,
      data: {
        accountId: this.aId,
        verificationId: model.verificationId,
        verificationToken: model.verificationToken,
        errorList: model.errorList,
        updateDataLink: this.updateDataLink,
      },
    });
  }
  ngOnInit() {
    this.ScriptLoaded$.subscribe((loaded) => {
      if (!loaded) {
        this.store.dispatch(ScriptLoadedAction());
        if (environment.greenIdEnv == 'test') {
          this.helper.loadStyle(
            'https://test-au.vixverify.com/df/assets/stylesheets/greenid.css'
          );
          this.helper.loadScript(
            'https://test-au.vixverify.com/df/javascripts/libs/jquery-3.5.1.min.js'
          );
          this.helper.loadScript(
            'https://test-au.vixverify.com/df/javascripts/greenidConfig.js'
          );
          this.helper.loadScript(
            'https://test-au.vixverify.com/df/javascripts/greenidui.min.js'
          );
        } else {
          this.helper.loadStyle(
            'https://au.vixverify.com/df/assets/stylesheets/greenid.css'
          );
          this.helper.loadScript(
            'https://au.vixverify.com/df/javascripts/libs/jquery-3.5.1.min.js'
          );
          this.helper.loadScript(
            'https://au.vixverify.com/df/javascripts/greenidConfig.js'
          );
          this.helper.loadScript(
            'https://au.vixverify.com/df/javascripts/greenidui.min.js'
          );
        }
      }
    });
  }
}
